






import { Component, Vue } from "vue-property-decorator";
import { getByRefresh } from "@/req/user";
import headerBox from "./header.vue";
import recharge from "./recharge.vue";
import withDraw from "./withDraw.vue";
import detail from "./detail.vue";

@Component({
  components: {
    headerBox,
    recharge,
    withDraw,
    detail
  }
})
export default class Logout extends Vue {
  public payformline = {};
  public tabArr = ["recharge", "withDraw", "detail"];
  public tabCom = "recharge";
  public mounted() {
    this.$store.dispatch("user/getByRefresh");
  }
  public async getByRefresh() {
    const obj = {
      token: this.$fn.cookies.getToken("token")
    };
    const res = await getByRefresh(obj);
    this.payformline = res.data.userinfo;
  }
  //   类型切换
  public tabsSkip(val) {
    this.tabCom = this.tabArr[val];
  }
}
